import { List } from 'immutable';
import LearningResult from './model';
import SkillResult from 'data/IndividualDevelopmentPlans/SkillResult';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'skillResults':
      return [key, new List(val.map((skillResult) => new SkillResult(skillResult)))];
    default:
      return [key, val];
  }
};

const create = (data) => new LearningResult(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/LearningResult/create.js